import {Component, Input} from '@angular/core';
import {Player} from "../../model/broadcast/player";
import {Broadcast} from "../../model/broadcast/broadcast";
import {UtilService} from "../../services/util.service";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-pitchers',
  templateUrl: './pitchers.component.html',
  styleUrls: ['./pitchers.component.scss'],
  standalone: true,
  imports: [NgIf, NgForOf],
})
export class PitchersComponent {

  @Input() pitchers: Player[];
  @Input() broadcast: Broadcast;

  constructor(public utilService: UtilService) {
  }
}
